/**
 * MobileBottomNav Component
 *
 * Bottom navigation bar for mobile devices.
 * Displays on screens < 768px width.
 * Replaces top tab navigation on mobile for better thumb accessibility.
 */

import React from 'react';
import { MessageCircle, BookOpen, Film, Calendar, Settings } from 'lucide-react';

function MobileBottomNav({ activeTab, onTabChange, onSettingsClick }) {
  const navItems = [
    { id: 'chat', label: 'Coaching', icon: MessageCircle },
    { id: 'notes', label: 'Notes', icon: BookOpen },
    { id: 'video', label: 'Video', icon: Film },
    { id: 'planning', label: 'Plan', icon: Calendar },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  const handleItemClick = (itemId) => {
    if (itemId === 'settings') {
      onSettingsClick();
    } else {
      onTabChange(itemId);
    }
  };

  return (
    <nav className="mobile-bottom-nav" role="navigation" aria-label="Main navigation">
      {navItems.map((item) => {
        const IconComponent = item.icon;
        const isActive = item.id === activeTab || (item.id === 'settings' && false);

        return (
          <button
            key={item.id}
            className={`mobile-nav-item ${isActive ? 'active' : ''}`}
            onClick={() => handleItemClick(item.id)}
            aria-current={isActive ? 'page' : undefined}
            aria-label={item.label}
          >
            <IconComponent className="nav-icon" size={20} />
            <span className="mobile-nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default MobileBottomNav;
